import * as React from 'react';
import Player from './../player/Player';
import Performances from './../player/Performances';
import NewTracks from './../views/NewTracks';
import navigationStore from './../../stores/navigation';
import { Views } from './../../enums/enums';
import Catalog from './Catalog';
import Search from './Search';
import Favorites from './Favorites';
import Singers from './Singers';
import Home from './Home';
import BackgroundMusic from './BackgroundMusic';
import PlayLists from './PlayLists';
import Settings from './Settings';
import Account from './Account';
import SongbookPerformances from './SongbookPerformances';
import Feedback from './Feedback';

function SongbookMobileContainer() {

  const currentView = navigationStore((state) => state.currentView);

  const renderView = (view) => {
    switch (view) {
      case Views.Search:
        return <Search isSongbook={true} />;
      case Views.Catalog:
        return <Catalog isSongbook={true} />;
      case Views.SongbookPerformances:
        return <SongbookPerformances />;
      default:
        return <NewTracks isSongbook={true} />;
    };
  };

  return (
    <div className="muvika-mobile-container">
      {renderView(currentView)}
    </div>
  );
}

export default SongbookMobileContainer;